export const INCIDENT_STATUSES = [
    "new",
    "triaged",
    "in_progress",
    "fix_deployed",
    "verified",
    "closed",
    "wont_fix",
    "duplicate",
    "spam",
];
export const TERMINAL_STATUSES = ["closed", "wont_fix", "duplicate", "spam"];
const MAIN_LINE = [
    "new",
    "triaged",
    "in_progress",
    "fix_deployed",
    "verified",
    "closed",
];
export const USER_VISIBLE_LABELS = {
    new: "Received",
    triaged: "Under review",
    in_progress: "Being worked on",
    fix_deployed: "Fix released",
    verified: "Fix confirmed",
    closed: "Closed",
    wont_fix: "Closed — not planned",
    duplicate: "Closed — duplicate",
    spam: null,
};
function isTerminal(status) {
    return TERMINAL_STATUSES.includes(status);
}
export function canTransition(from, to) {
    if (from === to)
        return false;
    if (isTerminal(from)) {
        // Nothing leaves a terminal status except an explicit reopen to triaged.
        return to === "triaged";
    }
    if (isTerminal(to)) {
        // Any active status may close out to a terminal status.
        return true;
    }
    // Both non-terminal: forward through the main line only.
    const fromIndex = MAIN_LINE.indexOf(from);
    const toIndex = MAIN_LINE.indexOf(to);
    if (fromIndex === -1 || toIndex === -1)
        return false;
    return toIndex > fromIndex;
}
